import React from 'react';
import { useIntl } from 'react-intl';

import { Theme, alpha } from '@mui/material/styles';
import Grid from '@mui/material/Grid';

import Typography from '@ts-core/components/Typography';
import Button from '@ts-core/components/Button';

export interface BaseStudentActivityCardProps {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;

  disableTypography?: boolean;

  score?: React.ReactNode;

  actionTitle?: React.ReactNode;
  onActionClick?: () => void;

  loading?: boolean;
}

const BaseStudentActivityCard = (props: BaseStudentActivityCardProps) => {
  const { title, subtitle, score = '-', loading = false, disableTypography = false, actionTitle, onActionClick } = props;
  const intl = useIntl();

  return (
    <Grid
      container
      sx={(theme: Theme) => ({
        borderBottom: 'solid 1px #e0e0e0',
        borderLeft: `solid .375rem ${loading ? alpha(theme.palette.secondary.main, 0.3) : theme.palette.secondary.main}`,
        borderTop: 'solid 1px #e0e0e0',
        borderRight: 'solid 1px #e0e0e0',
        p: 2,
        minHeight: '89px',
      })}
      alignItems="center"
    >
      <Grid item xs={10} sm={8}>
        {disableTypography ? (
          title
        ) : (
          <Typography variant="subtitle2" loading={loading} skeletonProps={{ width: '120px' }}>
            {title}
          </Typography>
        )}
        {disableTypography ? (
          subtitle
        ) : (
          <Typography variant="body2" color="textSecondary" loading={loading} skeletonProps={{ width: '80px' }}>
            {subtitle}
          </Typography>
        )}
      </Grid>
      <Grid item xs={2}>
        {!loading && (
          <Typography variant="body1" align="center" fontSize="1.5rem">
            {score}
          </Typography>
        )}
        <Typography variant="body2" align="center" color="textSecondary" loading={loading} skeletonProps={{ width: '30px' }}>
          {intl.formatMessage({ id: 'result' })}
        </Typography>
      </Grid>
      {onActionClick && (
        <Grid item xs={12} sm={2}>
          <Grid container justifyContent="center">
            <Button disabled={loading} onClick={onActionClick} color="secondary">
              {actionTitle}
            </Button>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default BaseStudentActivityCard;
